/**
 * Longest keyword contained in the description wins, matching import categorization.
 */
export function findBestMatchingKeyword(description, keywords = []) {
  if (!description) return null;
  const descriptionLower = description.toLowerCase();
  let best = null;

  for (const item of keywords) {
    const keyword = (item?.keyword || "").trim().toLowerCase();
    if (!keyword || !descriptionLower.includes(keyword)) continue;
    if (!best || keyword.length > best.keyword.length) {
      best = item;
    }
  }

  return best;
}
